export enum DealershipDepartments {
    SALES = 'SALES',
    AUTOSHOP = 'AUTOSHOP',
    RETAIL = 'SPAREPARTS',
    DAMAGE = 'DAMAGECENTER',
}

export enum DealershipPageSections {
    INFO = 'info',
    OPENING_HOURS = 'opening-hours',
    EMPLOYEES = 'employees',
    MAP = 'map',
    CARS = 'cars'
}